import { Box, Center, Grid, IconButton, Text } from "@chakra-ui/react";
import { CleanIcon } from "components/vectors/clean-icon";
import { DropdownField } from "components/dropdown-field";
import { InputField } from "components/input-field";

const dropdownBancosSaqueComplementar = [
  { name: "MASTER", value: "MASTER" },
  { name: "BMG", value: "BMG" },
  { name: "PAN", value: "PAN" },
];

interface FilterDataProps {
  banco?: string;
  idConvenio?: string;
  tipoCartao?: string;
  codigoTabela?: string;
}

type SaqueComplementarPipelineProps = {
  value: FilterDataProps[];
  onChange: (value: FilterDataProps[]) => void;
  isDisabled?: boolean;
};

export function SaqueComplementarPipeline({
  value,
  onChange,
  isDisabled,
}: SaqueComplementarPipelineProps) {
  const filterValue: FilterDataProps = value?.[0] || {};

  const onChangeValue = (key: string, val: string) => {
    const newValue = [{ ...filterValue, [key]: val }];
    onChange(newValue);
  };

  const clearValue = () => {
    onChange([]);
  };

  return (
    <>
      <Grid templateColumns="auto 32px" gap="8px" mb="10px">
        <DropdownField
          dropdownProps={{
            w: "100%",
            disabled: isDisabled,
          }}
          onChange={(value) => onChangeValue("banco", value)}
          value={filterValue.banco}
          options={dropdownBancosSaqueComplementar}
        />
        <Center>
          <IconButton
            aria-label=""
            variant="outline"
            size="sm"
            icon={<CleanIcon />}
            onClick={clearValue}
            disabled={isDisabled}
          />
        </Center>
      </Grid>

      <Box mb="10px">
        <InputField
          title="Código tabela"
          inputProps={{ bg: "#fff", isDisabled }}
          value={filterValue.codigoTabela || ""}
          onChange={(event) =>
            onChangeValue("codigoTabela", event.target.value)
          }
        />
      </Box>

      <Box mb="10px">
        <InputField
          title="Id convênio"
          inputProps={{ bg: "#fff", isDisabled }}
          value={filterValue.idConvenio || ""}
          onChange={(event) => onChangeValue("idConvenio", event.target.value)}
        />
      </Box>

      <Box mb="10px">
        <DropdownField
          title="Tipo cartão"
          options={[
            { name: "RMC", value: "RMC" },
            { name: "RCC", value: "RCC" },
          ]}
          dropdownProps={{ w: "100%", bg: "#fff", isDisabled }}
          value={filterValue.tipoCartao}
          onChange={(value) => onChangeValue("tipoCartao", value)}
        />
      </Box>
    </>
  );
}
